
var ajaxurl     =  '/wp-admin/admin-ajax.php';
var winHeight   =  window.innerHeight;
var winwidth    =  window.innerWidth;


function debounce(func, time){
    var time = time || 100; // 100 by default if no param
    var timer;
    return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}

function visibleWindowHeight() {
    /* create temporary element 'tmp' */
    var vpHeight,
        tmp = document.createElement('div');

    tmp.id = "vp_height_px";

    /* tmp height = viewport height (100vh) */
    tmp.setAttribute("style", "position:absolute;" +
        "top:0;" +
        "left:-1px;" +
        "width:1px;" +
        "height:100vh;");

    /* add tmp to page */
    document.body.appendChild(tmp);

    /* get tmp height in px */
    vpHeight = document.getElementById("vp_height_px").clientHeight;

    /* clean up */
    document.body.removeChild(tmp);

    /* pass value to callback and continue */
   return  vpHeight ;
}


function getAbsolutewidth(el) {
    // Get the DOM Node if you pass in a string
    el = (typeof el === 'string') ? document.querySelector(el) : el; 
  
    var styles = window.getComputedStyle(el);
    var margin = parseFloat(styles['marginLeft']) +
                 parseFloat(styles['marginRight']);
  
    return Math.ceil(el.offsetWidth + margin);
  }


function isTouchDevice() {

    return window.matchMedia('(hover: none)').matches;
}


function hasClass(el, cls) {
    
    var regexp = new RegExp('(\\s|^)' + cls + '(\\s|$)'),
        target = (typeof el.className === 'undefined') ? window.event.srcElement : el;
    return target.className.match(regexp); 
}



function appendHtml(el, str) {
	var div = document.createElement('div');
	div.innerHTML = str;
	while (div.children.length > 0) {
		el.appendChild(div.children[0]);
	}
}

function offset( elem ) {

    var docElem, win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;

    docElem = doc.documentElement;

    if ( typeof elem.getBoundingClientRect !== typeof undefined ) {
        box = elem.getBoundingClientRect();
    }
    win = getWindow( doc );
    return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft
    };
};

function offsetDimension( elem ) {
    var docElem, win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;
    docElem = doc.documentElement;
    if ( typeof elem.getBoundingClientRect !== typeof undefined ) {
        box = elem.getBoundingClientRect();
    }
    win = getWindow( doc );
    return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft,
        width: elem.offsetWidth,
        height: elem.offsetHeight,
        right: window.innerWidth - box.left - elem.offsetWidth,
        bottom: box.top + win.pageYOffset - docElem.clientTop - window.innerHeight
    };
};

function simulateClick(elem) {

    console.log(elem);
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};

function getWindow( elem ) {
    return isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

function isWindow( obj ) {
    return obj != null && obj === obj.window;
}

const loadAsyncScript = (src, async = true, type = "text/javascript") => {
    return new Promise((resolve, reject) => {
        try {
            const el = document.createElement("script");
            const container = document.head || document.body;

            el.type = type;
            el.async = async;
            el.src = src;

            el.addEventListener("load", () => {
                resolve({ status: true });
            });

            el.addEventListener("error", () => {
                reject({
                    status: false,
                    message: `Failed to load the script ${src}`
                });
            });

            container.appendChild(el);
        } catch (err) {
            reject(err);
        }
    });
};

function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}

function serialiseForm(e) {
    const formData = new FormData(e.target);
    return Object.fromEntries(formData.entries());
  } 

function loadingAni() {

    function show(container, state, position){

        let ajaxHtml = `<div class="ajax-loading ajax-loading-pos ajax-loading-${position}"><div class="lds-dual-ring"></div></div>`;

        if (state === 'neg') {
            ajaxHtml = `<div class="ajax-loading ajax-loading-neg  ajax-loading-${position}"><div class="lds-dual-ring"></div></div>`;
        }

        appendHtml(container, ajaxHtml); 
    }
    function hide(){
        const ajaxLoader = document.querySelector('.ajax-loading');
        if (ajaxLoader) {
              ajaxLoader.parentNode.removeChild(ajaxLoader);  
        }

    }
    return {
        show: show,
        hide: hide
    }
}

const loadScript = (FILE_URL, async = true, type = "text/javascript") => {
    return new Promise((resolve, reject) => {
        try {
            const scriptEle = document.createElement("script");
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src =FILE_URL;

            scriptEle.addEventListener("load", (ev) => {
                resolve({ status: true });
            });

            scriptEle.addEventListener("error", (ev) => {
                reject({
                    status: false,
                    message: `Failed to load the script ＄{FILE_URL}`
                });
            });

            document.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};

const loading = new loadingAni();







//@codekit-prepend "modules/scroll-smoother.js" 
//@codekit-prepend "modules/header-slideshow.js"
//@codekit-prepend "modules/header.js"
//@codekit-prepend "modules/section-parallax.js"
//@codekit-prepend "modules/dynamic-modal.js"
//@codekit-prepend "modules/menu-modal.js" 
//@codekit-prepend "modules/form-modal.js"
//@codekit-prepend "modules/video-modal.js"
//@codekit-prepend "modules/standort-select.js"
//@codekit-prepend "modules/dropdown-select.js"
//@codekit-prepend "modules/file-input.js"
//@codekit-prepend "modules/form-buts.js"
//@codekit-prepend "modules/stellen-items.js"
//@codekit-prepend "modules/count-up.js"
//@codekit-prepend "modules/content-slideshow.js"
//@codekit-prepend "modules/webp-animation.js"
//@codekit-prepend "modules/standort-select-content.js" 
//@codekit-prepend "modules/accordion.js" 
//@codekit-prepend "modules/scroll-animate.js" 
//@codekit-prepend "modules/image-sequenze.js" 
//@codekit-prepend "modules/events-collection.js" 
//@codekit-prepend "modules/cookie-consent.js" 



if (document.querySelector('.paralax-bg')) {
	const parallaxBg = new ParallaxBgImg();
}


const modal = new initDynamicModal();

const menuModal = new initMenuModal();

const formModal = new initFormModal();

const videoModal = new initVideoModal();

const _headerSlider = new headerSlider();



let headerSliderPageheader = document.querySelector('.header-slider-pageheader');

if (headerSliderPageheader) {
    _headerSlider.init(headerSliderPageheader,'pageheader');
}


const standortSelects = document.querySelectorAll('.standort-select');

if (standortSelects){

    console.log(standortSelects);

    standortSelects.forEach(function(standortSelecter){

        initStadortSelect(standortSelecter, false);

    });

}

if (document.querySelector('.but-form')) {

    initFormButs(document);

}

if (document.querySelector('.but-video')) {

    const videoButs = document.querySelectorAll('.but-video');

    videoButs.forEach(function(videoBut){

        videoBut.addEventListener('click', function(e){

            e.preventDefault();

            const videoUrl              = this.dataset.videoUrl;
            const videoPreviewImage     = this.dataset.videoPreviewImg;
                
            videoModal.loadModal(videoUrl, videoPreviewImage);
           
        });

    });

}

if (document.querySelector('.webp-animation-holder')) {

    const webpAnimations = new initwebpAnimations();
}

if (document.querySelector('.standort-select-content')) {

    const stadortSelectContent = new initStadortSelectContent();
}

if (document.querySelector('.count-up-holder')) {

    const _initCountup = new initCountup();
}

if (document.querySelector('.accordion-collapse')) {

    let _accordion = new initAccordion();
}

const contentSwipers = document.querySelectorAll('.content-slider-holder');

if (contentSwipers){

    contentSwipers.forEach(function(contentSwiper){

        const slider = new contentSlider();

        slider.init(contentSwiper);

    });

}
if (document.querySelector('.canvas-container')) {

    imageSequnze();
}

if (document.querySelector('.event-collection')) {

    eventsCollection();
}


if (document.querySelector('.scroll-animate')) {

    let _scrollAnimate = new scrollAnimate(); 
}

if (document.querySelector('#cookieconsent')) {
    const cookieDisclaimer = new initCookieDisclaimer;
}






